import React, { lazy, Suspense } from "react";
import { Loading } from "@nextui-org/react";
const Home = lazy(() => import("./Home"));
const ViewProduct = lazy(() => import("./ViewProduct"));
const Admin = lazy(() => import("./Admin"));
const Auth = lazy(() => import("./Auth"));
import { Route, Routes, Navigate } from "react-router-dom";

const Collection = lazy(() => import("./Collection"));
const Favorites = lazy(() => import("./Favorites"));
import Layout from "../components/Layout";
const Searching = lazy(() => import("./Searching"));

import { useAuth } from "../contexts/Auth";
const Access: React.FC<{ admin?: boolean; children: React.ReactElement }> = ({
  admin,
  children,
}) => {
  const { user, initializing } = useAuth();
  if (initializing) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "ADMIN") return <Navigate to="/" replace />;
  return children;
};
const Routers = () => {
  return (
    <Layout>
      <Suspense
        fallback={
          <div role="status" style={{ padding: 32 }}>
            <Loading /> Đang tải trang…
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collection/*" element={<Collection />} />
          <Route path="/product/detail/:name" element={<ViewProduct />} />
          <Route
            path="/manager"
            element={
              <Access admin>
                <Admin path="all-product" />
              </Access>
            }
          />
          <Route
            path="/manager/all-product"
            element={
              <Access admin>
                <Admin path="all-product" />
              </Access>
            }
          />
          <Route
            path="/manager/form"
            element={
              <Access admin>
                <Admin path="form" />
              </Access>
            }
          />
          <Route
            path="/manager/form/:id"
            element={
              <Access admin>
                <Admin path="form" />
              </Access>
            }
          />
          <Route
            path="/manager/all-cart"
            element={
              <Access admin>
                <Admin path="all-cart" />
              </Access>
            }
          />
          <Route
            path="/manager/all-types"
            element={
              <Access admin>
                <Admin path="all-types" />
              </Access>
            }
          />
          <Route
            path="/table"
            element={
              <Access admin>
                <Admin path="table" />
              </Access>
            }
          />
          <Route path="/login" element={<Auth auth={"login"} />} />
          <Route path="/register" element={<Auth auth={"register"} />} />
          <Route
            path="/favorites/"
            element={
              <Access>
                <Favorites />
              </Access>
            }
          />
          <Route path="/search" element={<Searching />} />
        </Routes>
      </Suspense>
    </Layout>
  );
};

export default Routers;
